"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDragAndDrop = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const useDragAndDrop = () => {
    const [dragIndex, setDragIndex] = react_1.default.useState(null);
    const [dragOverIndex, setDragOverIndex] = react_1.default.useState(null);
    const onDragStart = (e, index) => {
        e.stopPropagation();
        setDragIndex(index);
    };
    const onDragEnter = (e, index) => {
        e.preventDefault();
        if (index !== dragOverIndex) {
            setDragOverIndex(index);
        }
    };
    const onDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
    };
    const onDragEnd = (e) => {
        e.preventDefault();
        setDragIndex(null);
        setDragOverIndex(null);
    };
    const onDrop = (e, index, currentState) => {
        e.preventDefault();
        const items = [...currentState];
        // only checked items can change order || nothing changed
        if (!items[index].checked || index === dragIndex)
            return;
        const current = items[dragIndex];
        items.splice(dragIndex, 1);
        items.splice(index, 0, current);
        return items;
    };
    return {
        dragIndex,
        dragOverIndex,
        onDragStart,
        onDragEnter,
        onDragOver,
        onDragEnd,
        onDrop,
    };
};
exports.useDragAndDrop = useDragAndDrop;
